import { render } from "./Widget2.vue?vue&type=template&id=0a312d31&ts=true"
import script from "./Widget2.vue?vue&type=script&lang=ts"
export * from "./Widget2.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\ATTP_PC03\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__